import {
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { InputField } from "components";
import ActionButton from "components/atoms/ActionButton";
import Button from "components/atoms/Button";
import TableDataComponent from "components/organisms/TableData";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Ketenagaan from "services/Ketenagaan";
import { PageMode } from "utils/constant";
import { confirmAlert } from "react-confirm-alert";
import { errorToastNotif, successToastNotif } from "utils/common";
const ketenagaanService = new Ketenagaan();

const TableComponent = ({ handlePageModeChange, handleEditData }) => {
  const [state, setState] = useState({
    page: 1,
    limit: 10,
    searchKeyword: "",
    isLoading: true,
    data: [],
    totalData: 0,
    currentPage: 1,
    nextPage: null,
    previousPage: null,
  });

  const { currentUser } = useSelector((state) => state.authReducer);
  const history = useHistory();

  const getAllData = async () => {
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    try {
      let search = "";

      if (state.searchKeyword !== "") {
        search = `${state.searchKeyword}`;
      }

      const response = await ketenagaanService.getAll({
        page: state.page,
        limit: state.limit,
        type: "2",
        search,
      });
      setState((prevState) => ({
        ...prevState,
        data: response.ketenagaan,
        limit: response.limit,
        currentPage: response.currentPage,
        totalData: response.total,
        nextPage: response.nextPage,
        previousPage: response.previousPage,
      }));
    } catch (error) {
      console.log(error);
    } finally {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };

  useEffect(() => {
    getAllData();
  }, [state.page, state.searchKeyword]);

  const onPageChange = (page) => {
    setState((prevState) => ({
      ...prevState,
      page: page,
    }));
  };

  const onDataSearch = (e) => {
    const keyword = e.target.value;
    setState({
      ...state,
      searchKeyword: keyword,
    });
  };

  const onRemoveData = (id) => {
    confirmAlert({
      title: "Apakah anda yakin ingin menghapus data?",
      message: "Data akan dihapus secara permanen",
      buttons: [
        {
          label: "Ya",
          onClick: async () => {
            await ketenagaanService
              .remove(id)
              .then((res) => {
                getAllData();
                successToastNotif("Data berhasil dihapus");
              })
              .catch((err) => {
                console.log(err);
                errorToastNotif(err);
              });
          },
        },
        {
          label: "Tidak",
        },
      ],
    });
  };

  const columns = [
    {
      header: "Aksi",
      accessorKey: "action",
      cell: ({ row }) => (
        <div className="button-actions">
          <ActionButton
            onClick={() => handleEditData(row.original)}
            btnType={"edit"}
          />
          <ActionButton
            onClick={() => onRemoveData(row.original.kd_id)}
            btnType={"delete"}
          />
        </div>
      ),
    },

    {
      header: "Tgl disimpan",
      accessorKey: "tgl_simpan",
      cell: ({ getValue }) =>
        getValue() ? moment(getValue()).format("YYYY-MM-DD") : null,
    },
    {
      header: "Provinsi",
      accessorKey: "nama_provinsi",
    },
    {
      header: "Kabupaten",
      accessorKey: "nama_kabupaten",
    },
    {
      header: "Fasyankes",
      accessorKey: "nama_fasyankes",
    },
    {
      header: "Nama petugas surveilans/ rekam medik",
      accessorKey: "namapetugas",
    },

    {
      header: "Pelatihan SISMAL",
      accessorKey: "plthsismal",
    },
    {
      header: "Tahun pelatihan SISMAL terakhir",
      accessorKey: "thnplthsismal",
    },
    { header: "Ketersediaan Dokter Umum?", accessorKey: "dokterumum" },
    {
      header: "Ketersediaan dokter umum yang tersosialisasi tatalaksana malaria?",
      accessorKey: "dokterumum_sosmal",
    },
    {
      header: "Tahun sosialisasi terakhir",
      accessorKey: "thn_dokterumum_sosmal",
    },
    {
      header: "Ketersediaan dokter spesialis penyakit dalam",
      accessorKey: "dok_spd",
    },
    {
      header:
        "Ketersediaan dokter spesialis penyakit dalam yang sudah mendapatkan sosialisasi tatalaksana malaria?",
      accessorKey: "dok_spd_sosmal",
    },
    {
      header: "Tahun sosialisasi terakhir",
      accessorKey: "thn_dok_spd_sosmal",
    },
    {
      header: "Ketersediaan dokter spesialis anak?",
      accessorKey: "dok_anak",
    },
    {
      header:
        "Ketersediaan dokter spesialis anak yang sudah mendapatkan sosialisasi tatalaksana malaria?",
      accessorKey: "dok_anak_sosmal",
    },
    {
      header: "Tahun sosialisasi terakhir",
      accessorKey: "thn_dok_anak_sosmal",
    },
    {
      header: "Ketersediaan dokter spesialis kandungan?",
      accessorKey: "dok_kand",
    },
    {
      header:
        "Ketersediaan dokter spesialis kandungan yang sudah mendapatkan sosialisasi tatalaksana malaria?",
      accessorKey: "dokter_kand_sosmal",
    },
    {
      header: "Tahun sosialisasi terakhir",
      accessorKey: "thn_dokter_kand_sosmal",
    },
    { header: "Ketersediaan perawat?", accessorKey: "perawat" },
    {
      header: "Ketersediaan perawat yang tersosialisasi tatalaksana malaria?",
      accessorKey: "prwat_sosmal",
    },
    {
      header: "Tahun sosialisasi terakhir",
      accessorKey: "thn_jmlprwat_sosmal",
    },
    {
      header:
        "Ketersediaan perawat yang tersosialisasi skrining malaria pada balita di kab/kota dengan endemis tinggi?",
      accessorKey: "prwt_skrining_sosmal_balita",
    },
    {
      header: "Tahun sosialisasi terakhir",
      accessorKey: "thn_jmlprwt_skrining_sosmal_balita",
    },
    { header: "Ketersediaan Bidan?", accessorKey: "bidan" },
    {
      header: "Ketersediaan bidan yang tersosialisasi tatalaksana malaria?",
      accessorKey: "bidan_sosmal",
    },
    {
      header: "Tahun sosialisasi terakhir",
      accessorKey: "thn_jmlbidan_sosmal",
    },
    {
      header:
        "Ketersediaan bidan yang tersosialisasi skrining malaria pada kegiatan ANC di kab/kota dengan endemis tinggi?",
      accessorKey: "bidan_sosmal_anc",
    },
    {
      header: "Tahun sosialisasi terakhir",
      accessorKey: "thn_jmlbidan_sosmal_anc",
    },
    {
      header:
        "Ketersediaan bidan yang sudah mendapatkan sosialisasi skrining malaria pada balita di kab/kota dengan endemis tinggi?",
      accessorKey: "bidan_skrining_sosmal_balita",
    },
    {
      header: "Tahun sosialisasi terakhir",
      accessorKey: "thn_bidan_skrining_sosmal_balita",
    },
    {
      header: "Ketersediaan dokter spesialis patologi klinik?",
      accessorKey: "dok_patologi",
    },
    {
      header:
        "Ketersediaan dokter spesialis patologi klinik yg sudah mendapatkan sosialisasi QA diagnostik?",
      accessorKey: "dok_pato_sosmal",
    },
    {
      header: "Tahun sosialisasi terakhir",
      accessorKey: "thn_dok_pato_sosmal",
    },
       {
      header: "Ketersediaan dokter spesialis parasitologi klinik?",
      accessorKey: "dok_parasitologi",
    },
    {
      header:
        "Ketersediaan dokter spesialis parasitologi klinik yg sudah mendapatkan sosialisasi QA diagnostik?",
      accessorKey: "dok_parasitologi_sosmal",
    },
    {
      header: "Tahun sosialisasi terakhir",
      accessorKey: "thn_dok_parasitologi_sosmal",
    },
  ];
  const tableInstance = useReactTable({
    columns,
    data: state?.data,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
      <h1 className="page-title">Ketenagaan - RS/Klinik</h1>
      <div
        className="action-wrapper"
        style={{ marginTop: "10px", marginBottom: "24px" }}
      >
        <div className="action-button">
          {currentUser && currentUser.mode === "Online" && (
            <Button
              variant={"primary"}
              size={"normal"}
              onClick={() => handlePageModeChange(PageMode.add)}
            >
              Tambah Data Ketenagaan
            </Button>
          )}
        </div>
        <div className="action-search">
          <InputField
            placeholder={"Cari nama petugas"}
            onChange={onDataSearch}
            value={state.searchKeyword}
          />
        </div>
      </div>
      <TableDataComponent
        columnLength={columns?.length}
        tableInstance={tableInstance}
        onPageChange={onPageChange}
        loading={state.isLoading}
        currentPage={state.currentPage}
        limit={state.limit}
        nextPage={state.nextPage}
        previousPage={state.previousPage}
        total={state.totalData}
      />
    </div>
  );
};

export default TableComponent;
